module.exports = __webpack_public_path__ + "static/media/wordweb.e9349b5a.png";